import { render, staticRenderFns } from "./SetPreference.vue?vue&type=template&id=6b170ff9&"
import script from "./SetPreference.vue?vue&type=script&lang=js&"
export * from "./SetPreference.vue?vue&type=script&lang=js&"
import style0 from "./SetPreference.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports